import { useEffect, useState, useRef } from 'react';
import { InputText } from 'primereact/inputtext';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { classNames } from 'primereact/utils';
import { Password } from 'primereact/password';
import { PhoneInput, defaultCountries, parseCountry } from 'react-international-phone';
import { FileUpload } from 'primereact/fileupload';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { Checkbox } from 'primereact/checkbox';
import { RadioButton } from 'primereact/radiobutton';
import { Button } from 'primereact/button';
import { Badge } from 'primereact/badge';
import { Dialog } from 'primereact/dialog';
import axios from 'axios';
import { Toast } from 'primereact/toast';
import InputRut from '../components/InputRut';
import * as Yup from 'yup';
import useUserRole from '../hooks/useUserRole';
import 'yup-phone-lite';

import 'react-international-phone/style.css';
import 'primeicons/primeicons.css';
import './UploadPrescription.scss';
import useRut from '../hooks/useRut';
/* import FLAVORS from '../components/DiagnosticProduct'; */
/* const FLAVORS = ['Sin sabor', 'Carne', 'Salmón', 'Frutilla']; */

const UploadPrescription = () => {
    const [regions, setRegions] = useState([]);
    const [communes, setCommunes] = useState([]);
    const [adultConfirmation, setAdultConfirmation] = useState(false);
    const [confirmedNonRecipeHolder, setConfirmedNonRecipeHolder] = useState(null);
    const [region, setRegion] = useState(undefined);
    const [homeDelivery, setHomeDelivery] = useState(null);
    const [sending, setSending] = useState(false);
    const role = useUserRole();
    const [visible, setVisible] = useState(false);
    const [success, setSuccess] = useState(false);
    const [searchingDni, setSearchingDni] = useState(false);
    const [searchingHolderDni, setSearchingHolderDni] = useState(false);

    const { validate: validateRut } = useRut();

    const countries = defaultCountries.filter((country) => {
        const { iso2 } = parseCountry(country);
        return ['cl'].includes(iso2);
    });

    const formikRef = useRef(null);
    const prescriptionsUploadRef = useRef(null);
    const toast = useRef(null);

    const onClose = () => {
        setVisible(false);
    };

    const onRegionChange = (event) => {
        formikRef.current.setFieldValue('commune', undefined);
        formikRef.current.setFieldValue('region', event.value);
        setRegion(event.value);
    };

    const onValueChange = (event) => {
        formikRef.current.setFieldValue(event.target.name, event.value);
    };

    const onDniChange = (val) => {
        formikRef.current.setFieldValue('dni', val);
    };

    const onHolderDniChange = (val) => {
        formikRef.current.setFieldValue('holderDni', val);
    };

    const onPhoneChange = (val) => {
        formikRef.current.setFieldValue('phone', val);
    };

    useEffect(() => {
        axios.get('/api/regions').then((response) => {
            setRegions(response.data);
        });
    }, []);

    useEffect(() => {
        if (region) {
            axios.get('/api/regions/' + region.id + '/communes').then((response) => {
                setCommunes(response.data);
            });
        }
    }, [region]);

    const initialValues = {
        fullName: '',
        dni: '',
        phone: '',
        email: '',
        password: '',
        holderFullName: '',
        holderDni: '',
        region: undefined,
        commune: undefined,
        streetName: '',
        streetNumber: '',
        apartment: '',
        block: '',
        prescriptions: [],
        message: '',
        confirmedNonRecipeHolder: null,
        homeDelivery: null,
        isAdmin: role === 1,
    };

    // const initialValues = {
    //     fullName: 'Andrés Pino',
    //     dni: '14350190-6',
    //     phone: '+56968308304',
    //     email: 'andres.pino.g@gmail.com',
    //     password: '123456',
    //     holderFullName: '',
    //     holderDni: '',
    //     region: undefined,
    //     commune: undefined,
    //     streetName: '',
    //     streetNumber: '',
    //     apartment: '',
    //     block: '',
    //     prescriptions: [],
    //     message: '',
    //     confirmedNonRecipeHolder: null,
    //     homeDelivery: null,
    //     isAdmin: role === 1,
    // };

    Yup.addMethod(Yup.string, 'rut', function (errorMessage) {
        return this.test('rut', errorMessage, validateRut);
    });

    const validationSchema = Yup.object().shape({
        fullName: Yup.string().required('Ingresar el nombre completo'),
        dni: Yup.string().rut('Ingrese un RUT válido').required('Ingresar el RUT'),
        phone: Yup.string().phone('CL', 'Ingresar un número de teléfono válido').required('Ingresar un número de teléfono válido'),
        email: Yup.string().email('Ingresar un email válido').required('Ingresar un email válido'),
        password: Yup.string().when('isAdmin', {
            is: false,
            then: (schema) =>
                schema.required('Ingresa una contraseña').test('no-spaces', 'La contraseña no debe contener espacios', (value) => !/\s/.test(value)),
        }),
        confirmedNonRecipeHolder: Yup.boolean().required('Seleccione si es titular de la receta'),
        homeDelivery: Yup.boolean().required('Seleccione un método de entrega'),
        holderFullName: Yup.string().when('confirmedNonRecipeHolder', {
            is: true,
            then: (schema) => schema.required('Ingresar el nombre completo del titular de la receta'),
        }),
        holderDni: Yup.string().when('confirmedNonRecipeHolder', {
            is: true,
            then: (schema) => schema.rut('Ingrese un RUT válido').required('Ingresar el RUT del titular de la receta'),
        }),
        commune: Yup.object().when('homeDelivery', {
            is: true,
            then: (schema) => schema.required('Seleccionar una comuna'),
        }),
        streetName: Yup.string().when('homeDelivery', {
            is: true,
            then: (schema) => schema.required('Ingresar nombre de calle'),
        }),
        streetNumber: Yup.string().when('homeDelivery', {
            is: true,
            then: (schema) => schema.required('Ingresar numeración'),
        }),
        prescriptions: Yup.array().min(1, 'Adjuntar recetas'),
    });

    const onSubmit = (data) => {
        const formData = new FormData();
        for (const [key, value] of Object.entries(data)) {
            if (key === 'prescriptions') {
                for (const prescription of value) {
                    formData.append('prescriptions_files[]', prescription.file);
                    /* formData.append('prescriptions_flavors[]', prescription.flavor || ''); */
                    formData.append('prescriptions_quantities[]', prescription.quantity);
                }
            } else if (key === 'commune') {
                formData.append(key, value ? value.name : '');
            } else if (key === 'region') {
                formData.append(key, value ? value.name : '');
            } else {
                formData.append(key, value);
            }
        }
        formData.append('isRecipeHolder', !confirmedNonRecipeHolder);

        setSending(true);
        axios
            .post('/api/quotations', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            .then(() => {
                setSuccess(true);
                /* toast.current.clear();
                toast.current.show({ severity: 'success', detail: 'Cotización enviada correctamente. Lo contactaremos a la brevedad.' }); */
                formikRef.current.resetForm();
                prescriptionsUploadRef.current.clear();
            })
            .catch(() => {
                setSuccess(false);
                /* toast.current.clear();
                toast.current.show({ severity: 'error', detail: 'Ha ocurrido un error al intentar enviar la cotización. Favor intente nuevamente.' }); */
            })
            .finally(() => {
                setVisible(true);
                setSending(false);
            });
    };

    const onPrescriptionSelect = (event) => {
        const currentPrescriptions = formikRef.current.values.prescriptions;

        formikRef.current.setFieldValue(
            'prescriptions',
            event.files.map((file) => {
                return {
                    file,
                    flavor: currentPrescriptions.find((prescription) => prescription.file === file)?.flavor,
                    quantity: currentPrescriptions.find((prescription) => prescription.file === file)?.quantity || 1,
                };
            })
        );
    };

    const onPrescriptionRemove = (event) => {
        const prescriptions = formikRef.current.values.prescriptions.filter((prescription) => prescription.file !== event.file);
        formikRef.current.setFieldValue('prescriptions', prescriptions);
    };

    const onPrescriptionClear = () => {
        formikRef.current.setFieldValue('prescriptions', []);
    };
    /* 
    const onPrescriptionFlavorChange = (event, index) => {
        formikRef.current.setFieldValue('prescriptions[' + index + '].flavor', event.value);
    };
    */
    const onPrescriptionQuantityChange = (event, index) => {
        formikRef.current.setFieldValue('prescriptions[' + index + '].quantity', event.value);
    };

    const onDniSearchClick = () => {
        completePatientData(formikRef.current.values.dni);
    };

    const onHolderDniSearchClick = () => {
        completeHolderData(formikRef.current.values.holderDni);
    };

    const completePatientData = (dni) => {
        if (dni) {
            setSearchingDni(true);
            axios
                .get('/personas/rut/' + dni)
                .then((response) => {
                    if (response.status === 200) {
                        formikRef.current.setFieldValue('fullName', response.data.nombre || '');
                        formikRef.current.setFieldValue('phone', response.data.telefono || '');
                        formikRef.current.setFieldValue('email', response.data.mail || '');
                        formikRef.current.setFieldValue('streetName', response.data.direccion || '');
                        formikRef.current.setFieldValue('streetNumber', response.data.numeracion || '');
                        formikRef.current.setFieldValue('apartment', response.data.departamento || '');
                        formikRef.current.setFieldValue('block', response.data.block || '');

                        if (regions && regions.length > 0) {
                            const region = regions.find((region) => region.name === response.data.region);
                            if (region) {
                                formikRef.current.setFieldValue('region', region);
                            }
                        }
                        const newCommune = { id: 99999, name: response.data.ciudad || '' };
                        setCommunes([newCommune]);
                        formikRef.current.setFieldValue('commune', newCommune);
                    }
                })
                .catch(() => {
                    toast.current.clear();
                    toast.current.show({ severity: 'warn', detail: 'No se encontró información asociada al Rut' });
                })
                .finally(() => {
                    setSearchingDni(false);
                });
        }
    };

    const completeHolderData = (dni) => {
        if (dni) {
            setSearchingHolderDni(true);
            axios
                .get('/personas/rut/' + dni)
                .then((response) => {
                    if (response.status === 200) {
                        formikRef.current.setFieldValue('holderFullName', response.data.nombre);
                    }
                })
                .catch(() => {
                    toast.current.clear();
                    toast.current.show({ severity: 'warn', detail: 'No se encontró información asociada al Rut' });
                })
                .finally(() => {
                    setSearchingHolderDni(false);
                });
        }
    };

    const EmptyTemplate = () => {
        return <div className="text-center">Arrastra tus archivos aquí</div>;
    };

    const HeaderTemplate = ({ className, chooseButton }) => {
        return (
            <div className={className}>
                <div className="flex-grow-1">
                    <div>Adjunta las recetas. Puedes subir más de un archivo, uno por receta. </div>
                    <div>También puedes escoger el sabor de tu producto y la cantidad. </div>
                    <div className="text-center">{chooseButton}</div>
                </div>
            </div>
        );
    };

    const ItemTemplate = (_file, { previewElement, fileNameElement, removeElement, formatSize, index }) => {
        return (
            <>
                <div className="row prescription-item">
                    <div className="info col-12 col-md-7">
                        <div className="preview">{previewElement}</div>
                        <div className="description">
                            <span className="fw-bold">{fileNameElement}</span>
                            <Badge value={formatSize}></Badge>
                        </div>
                    </div>
                    {/*                     
                    <div className="col-12 col-md-3">
                        <label>Sabor:</label>
                        <Field name={'prescriptions[' + index + '].flavor'}>
                            {({ field, meta }) => (
                                <Dropdown
                                    {...field}
                                    onChange={(event) => {
                                        onPrescriptionFlavorChange(event, index);
                                    }}
                                    className={classNames('form-component', { 'p-invalid': meta.touched && meta.error })}
                                    options={FLAVORS}
                                    placeholder="Seleccione sabor"
                                />
                            )}
                        </Field>
                    </div>
                    */}
                    <div className="col-12 col-md-3">
                        <label>Cantidad:</label>
                        <div className="form-component">
                            <Field name={'prescriptions[' + index + '].quantity'}>
                                {({ field, meta }) => (
                                    <InputNumber
                                        value={field.value}
                                        className={classNames('form-component', { 'p-invalid': meta.touched && meta.error })}
                                        locale="es-CL"
                                        min={1}
                                        max={10}
                                        onValueChange={(event) => {
                                            onPrescriptionQuantityChange(event, index);
                                        }}
                                        showButtons
                                    />
                                )}
                            </Field>
                        </div>
                        <ErrorMessage name={'prescriptions[' + index + '].quantity'} component="div" className="p-error" />
                    </div>
                </div>
                <div className="remove">{removeElement}</div>
            </>
        );
    };

    return (
        <div className="upload-prescription">
            <Toast ref={toast} position="bottom-right" />

            <section className="section-sm bg-gray-1">
                <div className="container">
                    <div className="mb-4 text-center">
                        <h2 className="fw-bold">Registra tu receta magistral</h2>
                    </div>

                    <div className="grid">
                        <div className="row justify-content-center">
                            <div className="col-12 col-md-10 mb-3">
                                <Formik innerRef={formikRef} initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
                                    <Form>
                                        <div className="row justify-content-center mt-3">
                                            <div className="col-12 col-lg-4 pb-4">
                                                <label htmlFor="dni">RUT: </label>

                                                <div className={classNames({ 'p-inputgroup': role === 1, 'include-search-button': role === 1 })}>
                                                    <Field name="dni">
                                                        {({ field, meta }) => (
                                                            <InputRut
                                                                {...field}
                                                                onChange={onDniChange}
                                                                className={classNames('form-component', { 'p-invalid': meta.touched && meta.error })}
                                                            />
                                                        )}
                                                    </Field>
                                                    {role === 1 && (
                                                        <Button icon="bi bi-search" type="button" onClick={onDniSearchClick} loading={searchingDni} />
                                                    )}
                                                </div>
                                                <ErrorMessage name="dni" component="div" className="p-error" />
                                            </div>

                                            <div className="col-12 col-lg-8 pb-4">
                                                <label htmlFor="fullName">Nombre completo: </label>
                                                <Field name="fullName">
                                                    {({ field, meta }) => (
                                                        <InputText
                                                            {...field}
                                                            autoComplete="nope"
                                                            placeholder="Nombre y Apellidos"
                                                            maxLength={60}
                                                            className={classNames('form-component', { 'p-invalid': meta.touched && meta.error })}
                                                        />
                                                    )}
                                                </Field>
                                                <ErrorMessage name="fullName" component="div" className="p-error" />
                                            </div>
                                            <div className="col-12 col-lg-4 pb-4">
                                                <label htmlFor="phone">Teléfono: </label>
                                                <Field name="phone">
                                                    {({ field, meta }) => (
                                                        <PhoneInput
                                                            {...field}
                                                            onChange={onPhoneChange}
                                                            defaultCountry="cl"
                                                            countries={countries}
                                                            forceDialCode
                                                            className={classNames('form-component', { 'p-invalid': meta.touched && meta.error })}
                                                        />
                                                    )}
                                                </Field>
                                                <ErrorMessage name="phone" component="div" className="p-error" />
                                            </div>
                                            <div className="col-12 col-lg-4 pb-4">
                                                <label htmlFor="email">Email: </label>
                                                <Field name="email">
                                                    {({ field, meta }) => (
                                                        <InputText
                                                            {...field}
                                                            autoComplete="nope"
                                                            placeholder="Email"
                                                            maxLength={60}
                                                            className={classNames('form-component', { 'p-invalid': meta.touched && meta.error })}
                                                        />
                                                    )}
                                                </Field>
                                                <ErrorMessage name="email" component="div" className="p-error" />
                                            </div>
                                            <div className="col-12 col-lg-4 pb-4">
                                                <label htmlFor="password">Inventa una contraseña de seguimiento: </label>
                                                <Field name="password">
                                                    {({ field, meta }) => (
                                                        <Password
                                                            {...field}
                                                            placeholder="Contraseña"
                                                            maxLength={60}
                                                            feedback={false}
                                                            toggleMask
                                                            className={classNames('form-component', { 'p-invalid': meta.touched && meta.error })}
                                                        />
                                                    )}
                                                </Field>
                                                <ErrorMessage name="password" component="div" className="p-error" />
                                            </div>

                                            <div className="col-12 pb-4">
                                                <label htmlFor="homeDelivery">Selecciona el método de entrega: </label>
                                                <div className="d-flex gap-4">
                                                    <div className="d-flex align-items-center">
                                                        <RadioButton
                                                            inputId="homeDeliveryYes"
                                                            name="homeDelivery"
                                                            value="yes"
                                                            onChange={() => {
                                                                setHomeDelivery(true);
                                                                formikRef.current.setFieldValue('homeDelivery', true);
                                                            }}
                                                            checked={homeDelivery === true}
                                                        />

                                                        <label htmlFor="homeDeliveryYes" className="ms-2">
                                                            Envío a domicilio
                                                        </label>
                                                    </div>

                                                    <div className="d-flex align-items-center">
                                                        <RadioButton
                                                            inputId="homeDeliveryNo"
                                                            name="homeDelivery"
                                                            value="no"
                                                            onChange={() => {
                                                                setHomeDelivery(false);
                                                                formikRef.current.setFieldValue('homeDelivery', false);
                                                            }}
                                                            checked={homeDelivery === false}
                                                        />

                                                        <label htmlFor="homeDeliveryNo" className="ms-2">
                                                            Retiro en tienda{' '}
                                                            {homeDelivery === false && (
                                                                <span className="fw-bold">
                                                                    {' '}
                                                                    (Farmacia Narma, Gerónimo de Alderete 1383, Local 2, Vitacura. Horario: Lun-Vie 9:00 a 18:00
                                                                    hrs.){' '}
                                                                </span>
                                                            )}
                                                        </label>
                                                    </div>
                                                </div>

                                                <ErrorMessage name="homeDelivery" component="div" className="p-error" />
                                            </div>

                                            {homeDelivery && (
                                                <>
                                                    <div className="col-md-6 pb-4">
                                                        <label htmlFor="region">Región: </label>
                                                        <Field name="region">
                                                            {({ field, meta }) => (
                                                                <Dropdown
                                                                    {...field}
                                                                    onChange={onRegionChange}
                                                                    className={classNames('form-component', { 'p-invalid': meta.touched && meta.error })}
                                                                    options={regions}
                                                                    optionLabel="name"
                                                                    placeholder="Seleccione región"
                                                                    emptyMessage="Sin regiones"
                                                                />
                                                            )}
                                                        </Field>
                                                        <ErrorMessage name="region" component="div" className="p-error" />
                                                    </div>
                                                    <div className="col-md-6 pb-4">
                                                        <label htmlFor="commune">Comuna: </label>
                                                        <Field name="commune">
                                                            {({ field, meta }) => (
                                                                <Dropdown
                                                                    {...field}
                                                                    onChange={onValueChange}
                                                                    className={classNames('form-component', { 'p-invalid': meta.touched && meta.error })}
                                                                    options={communes}
                                                                    optionLabel="name"
                                                                    placeholder="Seleccione comuna"
                                                                    emptyMessage="Seleccione una región para cargar sus comunas"
                                                                />
                                                            )}
                                                        </Field>
                                                        <ErrorMessage name="commune" component="div" className="p-error" />
                                                    </div>
                                                    <div className="col-md-6 pb-4">
                                                        <label htmlFor="streetName">Dirección (Calle): </label>
                                                        <Field name="streetName">
                                                            {({ field, meta }) => (
                                                                <InputText
                                                                    {...field}
                                                                    autoComplete="nope"
                                                                    placeholder="Calle"
                                                                    maxLength={230}
                                                                    className={classNames('form-component', { 'p-invalid': meta.touched && meta.error })}
                                                                />
                                                            )}
                                                        </Field>
                                                        <ErrorMessage name="streetName" component="div" className="p-error" />
                                                    </div>
                                                    <div className="col-md-6 pb-4">
                                                        <label htmlFor="streetNumber">Número: </label>
                                                        <Field name="streetNumber">
                                                            {({ field, meta }) => (
                                                                <InputText
                                                                    {...field}
                                                                    autoComplete="nope"
                                                                    placeholder="Número"
                                                                    maxLength={20}
                                                                    className={classNames('form-component', { 'p-invalid': meta.touched && meta.error })}
                                                                />
                                                            )}
                                                        </Field>
                                                        <ErrorMessage name="streetNumber" component="div" className="p-error" />
                                                    </div>
                                                    <div className="col-md-6 pb-4">
                                                        <label htmlFor="apartment">Departamento: </label>
                                                        <Field name="apartment">
                                                            {({ field, meta }) => (
                                                                <InputText
                                                                    {...field}
                                                                    autoComplete="nope"
                                                                    placeholder="Departamento"
                                                                    maxLength={20}
                                                                    className={classNames('form-component', { 'p-invalid': meta.touched && meta.error })}
                                                                />
                                                            )}
                                                        </Field>
                                                        <ErrorMessage name="apartment" component="div" className="p-error" />
                                                    </div>
                                                    <div className="col-md-6 pb-4">
                                                        <label htmlFor="block">Block: </label>
                                                        <Field name="block">
                                                            {({ field, meta }) => (
                                                                <InputText
                                                                    {...field}
                                                                    autoComplete="nope"
                                                                    placeholder="Block"
                                                                    maxLength={20}
                                                                    className={classNames('form-component', { 'p-invalid': meta.touched && meta.error })}
                                                                />
                                                            )}
                                                        </Field>
                                                        <ErrorMessage name="block" component="div" className="p-error" />
                                                    </div>
                                                </>
                                            )}

                                            <div className="col-12 pb-4">
                                                <label htmlFor="confirmedNonRecipeHolder">¿Es usted el titular de la receta? </label>
                                                <div className="d-flex gap-4">
                                                    <div className="d-flex align-items-center">
                                                        <RadioButton
                                                            inputId="confirmedNonRecipeHolderYes"
                                                            name="confirmedNonRecipeHolder"
                                                            value="yes"
                                                            onChange={() => {
                                                                setConfirmedNonRecipeHolder(false);
                                                                formikRef.current.setFieldValue('confirmedNonRecipeHolder', false);
                                                            }}
                                                            checked={confirmedNonRecipeHolder === false}
                                                        />

                                                        <label htmlFor="confirmedNonRecipeHolderYes" className="ms-2">
                                                            Sí
                                                        </label>
                                                    </div>

                                                    <div className="d-flex align-items-center">
                                                        <RadioButton
                                                            inputId="confirmedNonRecipeHolderNo"
                                                            name="confirmedNonRecipeHolder"
                                                            value="no"
                                                            onChange={() => {
                                                                setConfirmedNonRecipeHolder(true);
                                                                formikRef.current.setFieldValue('confirmedNonRecipeHolder', true);
                                                            }}
                                                            checked={confirmedNonRecipeHolder === true}
                                                        />
                                                        <label htmlFor="confirmedNonRecipeHolderNo" className="ms-2">
                                                            No
                                                        </label>
                                                    </div>
                                                </div>

                                                <ErrorMessage name="confirmedNonRecipeHolder" component="div" className="p-error" />
                                            </div>

                                            {confirmedNonRecipeHolder && (
                                                <>
                                                    <div className="col-12 col-lg-4 pb-4">
                                                        <label htmlFor="holderDni">RUT del titular de la receta: </label>
                                                        <div className={classNames({ 'p-inputgroup': role === 1, 'include-search-button': role === 1 })}>
                                                            <Field name="holderDni">
                                                                {({ field, meta }) => (
                                                                    <InputRut
                                                                        {...field}
                                                                        onChange={onHolderDniChange}
                                                                        className={classNames('form-component', { 'p-invalid': meta.touched && meta.error })}
                                                                    />
                                                                )}
                                                            </Field>
                                                            {role === 1 && (
                                                                <Button
                                                                    icon="bi bi-search"
                                                                    type="button"
                                                                    onClick={onHolderDniSearchClick}
                                                                    loading={searchingHolderDni}
                                                                />
                                                            )}
                                                        </div>
                                                        <ErrorMessage name="holderDni" component="div" className="p-error" />
                                                    </div>
                                                    <div className="col-12 col-lg-8 pb-4">
                                                        <label htmlFor="holderFullName">Nombre completo del titular de la receta: </label>
                                                        <Field name="holderFullName">
                                                            {({ field, meta }) => (
                                                                <InputText
                                                                    {...field}
                                                                    autoComplete="off"
                                                                    placeholder="Nombre y Apellidos Titular"
                                                                    maxLength={60}
                                                                    className={classNames('form-component', { 'p-invalid': meta.touched && meta.error })}
                                                                />
                                                            )}
                                                        </Field>
                                                        <ErrorMessage name="holderFullName" component="div" className="p-error" />
                                                    </div>
                                                </>
                                            )}

                                            <div className="pb-4">
                                                <label>Recetas:</label>
                                                <Field name="prescriptions">
                                                    {({ meta }) => (
                                                        <div
                                                            className={classNames('form-component', 'file-upload', { 'p-invalid': meta.touched && meta.error })}
                                                        >
                                                            <FileUpload
                                                                ref={prescriptionsUploadRef}
                                                                name="prescriptions[]"
                                                                multiple
                                                                accept="image/*,application/pdf"
                                                                emptyTemplate={EmptyTemplate}
                                                                headerTemplate={HeaderTemplate}
                                                                itemTemplate={ItemTemplate}
                                                                chooseOptions={{ label: 'Elegir archivos' }}
                                                                onSelect={onPrescriptionSelect}
                                                                onRemove={onPrescriptionRemove}
                                                                onClear={onPrescriptionClear}
                                                            />
                                                        </div>
                                                    )}
                                                </Field>
                                                <ErrorMessage name="prescriptions" component="div" className="p-error" />
                                            </div>

                                            <div className="pb-4">
                                                <label htmlFor="message">Mensaje:</label>
                                                <Field name="message">
                                                    {({ field, meta }) => (
                                                        <InputTextarea
                                                            {...field}
                                                            maxLength={250}
                                                            rows={3}
                                                            className={classNames('form-component', { 'p-invalid': meta.touched && meta.error })}
                                                        />
                                                    )}
                                                </Field>
                                            </div>

                                            <div className="d-flex flex-column justify-content-center align-items-center">
                                                <p className="mb-1 fw-bold">Debes ser mayor de edad para poder enviar la cotización</p>

                                                <div className="d-flex align-items-center">
                                                    <Checkbox
                                                        inputId="ageConfirmation"
                                                        onChange={(e) => setAdultConfirmation(e.checked)}
                                                        checked={adultConfirmation}
                                                    ></Checkbox>
                                                    <label htmlFor="ageConfirmation" className="ms-2">
                                                        Confirmo que soy mayor de edad
                                                    </label>
                                                </div>
                                            </div>

                                            <div className="mt-3 text-center">
                                                <Button
                                                    type="submit"
                                                    label="Enviar cotización"
                                                    severity="secondary"
                                                    loading={sending}
                                                    disabled={!adultConfirmation || sending}
                                                />
                                            </div>

                                            <div className="small mt-5">
                                                Si presenta problemas al cargar su receta, por favor enviar{' '}
                                                <span className="fw-bold">nombre y apellidos, dirección de despacho, y receta</span> al email{' '}
                                                <a href="mailto:contacto@narma.cl">contacto@narma.cl</a>
                                            </div>

                                            <div className="mt-5 text-left">
                                                <div>Información:</div>
                                                <div>- La receta magistral será cotizada y fabricada por RpFARMA</div>
                                            </div>
                                        </div>
                                    </Form>
                                </Formik>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Dialog visible={visible} onHide={onClose} showHeader={false} contentStyle={{ borderRadius: '4px' }} modal>
                <div className="p-4 text-center">
                    {success ? (
                        <>
                            <i className="pi pi-file-check text-success" style={{ fontSize: '2rem' }}></i>
                            <h4 className="text-success">Receta enviada con éxito</h4>
                            <p>En breve recibirá una copia en su correo. Nos pondremos en contacto con usted a la brevedad.</p>
                        </>
                    ) : (
                        <>
                            <i className="pi pi-times text-danger" style={{ fontSize: '2rem' }}></i>
                            <h4 className="text-danger">Ha ocurrido un error al intentar enviar la cotización.</h4>
                            <p>Favor intente nuevamente.</p>
                        </>
                    )}
                    <Button label="Cerrar" icon="pi pi-times" className="p-button-secondary mt-3" onClick={onClose} />
                </div>
            </Dialog>
        </div>
    );
};

export default UploadPrescription;
